<p-select
  [options]="formField.options"
  [formControl]="ctrl"
  optionLabel="label"
  optionValue="value"
  [placeholder]="formField.placeholder"
  styleClass="w-full"
  [disabled]="!!disabled || formField.disabled || ctrl.disabled"
>
  <ng-template #selectedItem let-selectedOption>
    @if (selectedOption) {
      @if (selectedOption?.label) {
        <span>{{ selectedOption.label }}</span>
      } @else if (selectedOption?.htmlLabel) {
        <span [innerHTML]="selectedOption.htmlLabel" class="w-full flex"></span>
      }
    }
  </ng-template>
  <ng-template let-option #item>
    @if (option?.label) {
      <span>{{ option.label }}</span>
    } @else if (option?.htmlLabel) {
      <span [innerHTML]="option.htmlLabel" class="w-full flex"></span>
    }
  </ng-template>
</p-select>
